module.exports = __webpack_public_path__ + "static/media/elencoVoucher.698810aa.png";